import React from "react";

import axios from "axios";
import { createRoot } from "react-dom/client";

import App from "./App";
import Config from "./config";
import "/src/index.css";
import initializeSentry from "./tracking/sentry";

// Configure axios, if more config is needed move to another file and import
axios.defaults.baseURL = Config.api.HOST;

initializeSentry();

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
